import type { PrefetchContext, PrefetchedDataProps } from 'src/shared/prefetch';

import { useLocale } from 'src/app/shared/hooks/l10n';

import { prefetchMiscContentDetailsPageDataFromApi, useMiscContentDetailsPageDataFromApi } from './pageData';

export type MiscContentDetailsPagePrefetchedContext = Readonly<{
	pageData: Parameters<typeof useMiscContentDetailsPageDataFromApi>[0];
}>;

export type MiscContentDetailsPageCombinedState = ReturnType<typeof useMiscContentDetailsPageDataFromApi>;

export function usePageContext(
	countryCode: string,
	slug: string,
	prefetchedData?: MiscContentDetailsPagePrefetchedContext,
): MiscContentDetailsPageCombinedState {
	const locale = useLocale();

	return useMiscContentDetailsPageDataFromApi(prefetchedData?.pageData, { countryCode, locale, slug });
}

export async function prefetchPageContext(
	countryCode: string,
	slug: string,
	context: PrefetchContext,
): Promise<MiscContentDetailsPagePrefetchedContext> {
	const { locale } = context.l10n;

	return { pageData: await prefetchMiscContentDetailsPageDataFromApi(context, { countryCode, locale, slug }) };
}

export type MiscContentDetailsPagePrefetchedDataProps = PrefetchedDataProps<MiscContentDetailsPagePrefetchedContext>;
